import Fade from "@/Shared/Animations/CustomComponents/Fade";
import RevealBox from "@/Shared/Layout/CustomComponents/RevealBox";
import type { UUID } from "@/Shared/types";
import type { EquipmentType } from "@freightsimple/generated-dashboard-openapi-client/models/EquipmentType";
import type { LineItem } from "@freightsimple/generated-dashboard-openapi-client/models/LineItem";
import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import type { SharedDedicated } from "@freightsimple/generated-dashboard-openapi-client/models/SharedDedicated";
import { BookShipmentDedicatedLogisticsOffer } from "./BookShipmentDedicatedLogisticsOffer";
import { BookShipmentDedicatedLogisticsOfferButtonPositionType } from "../Types/BookShipmentDedicatedLogisticsOfferButtonPositionType";

interface LogisticsQuoteRowProps {
  shipmentId: UUID;
  pickupDate: string;
  pickupDeadline: string | undefined;
  pickupLocation: PreQuoteLocation;
  deliveryLocation: PreQuoteLocation;
  deliveryDeadline: string | undefined;
  lineItems: LineItem[];
  equipmentType: EquipmentType | undefined;
  exclusiveUse: boolean;
  tarpRequired: boolean;
  linearFeet: number | undefined;
  pickupReferenceNumber?: string | undefined;
  deliveryReferenceNumber?: string | undefined;
  deliveryAmazonReferenceId?: string | undefined;
  deliveryAmazonShipmentId?: string | undefined;
  onRequestManualQuotes: (
    shipmentId: UUID,
    equipmentType: EquipmentType,
    sharedDedicated: SharedDedicated,
    tarpRequired: boolean | undefined,
    linearFeet: number | undefined,
    notes: string,
  ) => Promise<void>;
}

export function BookShipmentLogisticsQuoteRow(props: LogisticsQuoteRowProps) {
  return (
    <RevealBox
      header={() => {
        return (
          <div className="flex flex-row items-center">
            <div className="text-[26px]">🦸‍♀️</div>
            <div className="w-4" />
            <div className="flex flex-col flex-nowrap items-start">
              <div className="text-[18px] font-medium">
                Looking for more options?
              </div>
              <div className="-mt-[2px] text-[14px] text-content-muted">
                FreightSimple's Dedicated Logistics Team can help find other
                options for this shipment
              </div>
            </div>
          </div>
        );
      }}
      body={(open) => {
        return (
          <Fade show={open}>
            <BookShipmentDedicatedLogisticsOffer
              pickupDeadline={props.pickupDeadline}
              hideModifyButton
              onModify={function () {}}
              onRequestManualQuotes={props.onRequestManualQuotes}
              shipmentId={props.shipmentId}
              lineItems={props.lineItems}
              pickupDate={props.pickupDate}
              pickupLocation={props.pickupLocation}
              deliveryLocation={props.deliveryLocation}
              deliveryDeadline={props.deliveryDeadline}
              buttonPosition={
                BookShipmentDedicatedLogisticsOfferButtonPositionType.Inline
              }
              equipmentType={props.equipmentType}
              exclusiveUse={props.exclusiveUse}
              tarpRequired={props.tarpRequired}
              linearFeet={props.linearFeet}
              pickupReferenceNumber={props.pickupReferenceNumber}
              deliveryReferenceNumber={props.deliveryReferenceNumber}
              deliveryAmazonReferenceId={props.deliveryAmazonReferenceId}
              deliveryAmazonShipmentId={props.deliveryAmazonShipmentId}
            />
          </Fade>
        );
      }}
    />
  );
}
